import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { Estado } from "src/app/model/estado.model";
import { TarefasHonraService } from "./tarefas-honra.service";
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import moment from "moment";
import { DatePipe } from '@angular/common';


@Component({
    selector: 'app-tarefas-honra',
    templateUrl: './tarefas-honra.component.html',
    styleUrls: ['./tarefas-honra.component.scss'],
    standalone: false
})
export class TarefasHonraComponent implements OnInit{


  public cnpjAgenteFinanceiro: string;
  public valorDisponivel: number;
  public tranches: Tranche[] = [];
  public ideTranche: number;
  public alterarIdSh: number;
  public removerIdSh: number;
  public desfazerIdSh: number;
  public simularPagamentoIdSh: number;
  public processarSHCreditoLivreIdSh: number;
  public processarSHRepasseIdSh: number;
  public estados: Estado[] = [];
  public estadosHonra: Estado[] = [];
  public idEstado: string;
  public idEstadoHonra: string;
  public anoMesSolicitacaoDeHonra: string | Date;
  public anoMesLimiteDisponivel: string | Date;
  public idOperacao: number;

  constructor(
    private honraService: TarefasHonraService,
    private messageService: MessageChannelService,
    private trancheService: TrancheService,
    private alertService: BnAlertsService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private loadingService: BnLoadingService){

      this.estados = this.activatedRoute.snapshot.data['dominios'].estadosSolicitacaoHonra;
      this.estadosHonra = this.activatedRoute.snapshot.data['dominios'].estadosHonra;
    }

  ngOnInit(): void {
    this.trancheService.getTranches().subscribe (tranches => {
      this.tranches = tranches;
    });

  }

  public alterarLimiteStopLoss() {
    if(this.cnpjAgenteFinanceiro == null || this.ideTranche == null || this. valorDisponivel == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar a alteração');
    } else {
        this.loadingService.bloqueiaTela();
        let anoMesRefStopLoss:string = this.datePipe.transform(this.anoMesLimiteDisponivel, 'yyyyMM');
        this.honraService.alterarLimiteStopLoss(this.cnpjAgenteFinanceiro, this.ideTranche, anoMesRefStopLoss, this.valorDisponivel)
          .subscribe(() => {
            this.messageService.addMessage({
              title: 'Sucesso',
                type: 'CRUD_OPERATION',
                level: messageLevel.SUCCESS,
                message: 'Limite de Stop Loss alterado com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
  }

  public alterarEstadoSolicitacaoHonra() {
    if(this.alterarIdSh == null || this.idEstado == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar a alteração');
    } else {
        this.loadingService.bloqueiaTela();
        this.honraService.alterarEstadoSolicitacaoHonra(this.alterarIdSh, this.idEstado)
          .subscribe(() => {
            this.messageService.addMessage({
              title: 'Sucesso',
                type: 'CRUD_OPERATION',
                level: messageLevel.SUCCESS,
                message: 'Estado de Solicitação de Honra alterado com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
  }

  public alterarEstadoHonra() {
    if(this.alterarIdSh == null || this.idEstadoHonra == null) {
      this.alertService.alertaErro('Erro', 'Preencha todos os campos para realizar a alteração');
    } else {
        this.loadingService.bloqueiaTela();
        this.honraService.alterarEstadoSolicitacaoHonra(this.alterarIdSh, this.idEstadoHonra)
          .subscribe(() => {
            this.messageService.addMessage({
              title: 'Sucesso',
                type: 'CRUD_OPERATION',
                level: messageLevel.SUCCESS,
                message: 'Estado da Honra alterado com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
  }

  public fecharJanelaSolicitacaoHonra() {
    this.loadingService.bloqueiaTela();
    this.honraService.fecharJanelaSolicitacaoHonra().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Fechamento da janela rodado com sucesso.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public rodarStopLoss() {
    this.loadingService.bloqueiaTela();
    this.honraService.rodarStopLoss().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Stop loss rodado com sucesso.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public processarSolicitacoesHonraCreditoLivre() {
    this.loadingService.bloqueiaTela();
    this.honraService.processarSolicitacoesHonraCreditoLivre().subscribe((msg) => {
      this.messageService.addMessage({
        title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: msg
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public processarSolicitacaoHonraCreditoLivre() {
    if(this.processarSHCreditoLivreIdSh == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo Id Solicitação Honra');
    } else {
        this.loadingService.bloqueiaTela();
        this.honraService.processarSolicitacoesHonraCreditoLivreSemCriticas(this.processarSHCreditoLivreIdSh).subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
              type: 'CRUD_OPERATION',
              level: messageLevel.SUCCESS,
              message: 'Processamento da solicitação de honra realizado com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
  }

  public processarSolicitacoesHonraRepasse() {
    this.loadingService.bloqueiaTela();
    this.honraService.processarSolicitacoesHonraRepasse().subscribe((msg) => {
      this.messageService.addMessage({
        title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: msg
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public processarSolicitacaoHonraRepasse() {
    if(this.processarSHRepasseIdSh == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo Id Solicitação Honra');
    } else {
        this.loadingService.bloqueiaTela();
        this.honraService.processarSolicitacoesHonraRepasseSemCriticas(this.processarSHRepasseIdSh).subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
              type: 'CRUD_OPERATION',
              level: messageLevel.SUCCESS,
              message: 'Processamento da solicitação de honra realizado com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
  }

  public desfazerProcessamentoDeHonra() {
    this.loadingService.bloqueiaTela();
    this.honraService.desfazerProcessamentoDeHonra(this.desfazerIdSh).subscribe((msg) => {
      this.messageService.addMessage({
        title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: msg
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public simularPagamento() {
    if(this.simularPagamentoIdSh == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo Id Solicitação Honra');
    } else {
        this.loadingService.bloqueiaTela();
        this.honraService.simularPagamento(this.simularPagamentoIdSh).subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
              type: 'CRUD_OPERATION',
              level: messageLevel.SUCCESS,
              message: 'Pagamento simulado com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
  }

  public removerSolicitacaoHonra() {
    if(this.removerIdSh == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo Id Solicitação Honra');
    } else {
        this.loadingService.bloqueiaTela();
        this.honraService.removerSolicitacaoHonra(this.removerIdSh).subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
              type: 'CRUD_OPERATION',
              level: messageLevel.SUCCESS,
              message: 'Solicitação removida com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
  }

  public monitorarPagamentoFaturas() {
    this.loadingService.bloqueiaTela();
    this.honraService.monitorarPagamentoFaturas().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Monitoramento realizado com sucesso. Confira o estado do processamento nos detalhes das solicitações de honra.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public emitirExtratosPagamento() {
    this.loadingService.bloqueiaTela();
    this.honraService.emitirExtratosPagamento().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Extratos do pagamento emitido com sucesso.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public emitirRelatoriosValoresHonradosRecuperar() {
    this.loadingService.bloqueiaTela();
    this.honraService.emitirRelatoriosValoresHonradosRecuperar().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Relatórios dos valores honrados recuperados emitido com sucesso.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }
  public emitirFaturas() {
    this.loadingService.bloqueiaTela();
    this.honraService.emitirFaturas().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Faturas emitidas com sucesso com sucesso.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }
  public emitirRelatoriosProvisaoPagamentos() {
    this.loadingService.bloqueiaTela();
    this.honraService.emitirRelatoriosProvisaoPagamentos().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Relatórios - Provisão pagamentos emitidos com sucesso.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }
  public emitirRelatorioDefin() {
    this.loadingService.bloqueiaTela();
    this.honraService.emitirRelatorioDefin().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Relatório DEFIN emitido com sucesso.'
      })
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public consultaJanelaSolicitacaoHonra() {
    let dataJanela: string;
    if(this.anoMesSolicitacaoDeHonra == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo de data');
    } else {
      this.loadingService.bloqueiaTela();
      dataJanela = this.datePipe.transform(this.anoMesSolicitacaoDeHonra, 'yyyyMM');
        this.honraService.consultarJanelaSolicitacaoHonra(dataJanela).subscribe((resp: any) => {
          if (resp) {
            this.messageService.addMessage({
                type: 'CRUD_OPERATION',
                level: messageLevel.WARNING,
                message: 'Já existe janela para a data selecionada.'
            })
          }
          else {
            this.messageService.addMessage({
              type: 'CRUD_OPERATION',
              level: messageLevel.WARNING,
              message: 'Não existe janela para a data selecionada.'
          })
          }
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
  }

  public criaJanelaSolicitacaoHonra() {
    let dataJanela: string;
    if(this.anoMesSolicitacaoDeHonra == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo de data');
    } else {
      dataJanela = this.datePipe.transform(this.anoMesSolicitacaoDeHonra, 'yyyyMM');
        this.honraService.criarJanelaSolicitacaoHonra(dataJanela).subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
              type: 'CRUD_OPERATION',
              level: messageLevel.SUCCESS,
              message: 'Janela de solictação de honra criada com sucesso.'
          })
        })
      }
  }

  public criaSolicitacaoHonra() {
    if(this.idOperacao == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo Id Operacão');
    } else {
        this.loadingService.bloqueiaTela();
        this.honraService.criarSolicitacaoHonra(this.idOperacao).subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Solicitação de honra criada com sucesso.'
          })
          this.loadingService.liberaTela();
        }, (error) => {
          this.loadingService.liberaTela();
        })
      }
  }


  limparSolicitacaoHonra(){
    this.anoMesSolicitacaoDeHonra = null;
  }
  limparLimiteDisponivel(){
    this.cnpjAgenteFinanceiro = null ;
    this.ideTranche = null ;
    this.anoMesLimiteDisponivel = null ;
    this.valorDisponivel = null ;
  }
  limparCriarSolicitacaoHonra(){
    this.idOperacao = null ;
  }
  limparEstadoSolicitacaoHonra(){
    this.alterarIdSh = null ;
    this.idEstado = null ;
  }
  limparRemoverSolicitacaoHonra(){
    this.removerIdSh = null;
  }

  limparDesfazerProcessamentoDeHonra(){
    this.desfazerIdSh = null ;
  }
  limparSimularPagamento(){
    this.simularPagamentoIdSh = null;
  }

}


